/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState } from "react";
import { FilterComparisonOperator, SortOrder } from "~/generated/graphql";

type FilterCondition = {
  field: string;
  operator: FilterComparisonOperator;
  values?: string[];
};

type FilterState = {
  filterBy?: FilterCondition[];
  phrase?: string;
};

type SearchState = {
  page: number;
  limit: number;
  sort?: {
    field: string;
    order?: SortOrder;
  };
  filter?: FilterState;
};

const DEFAULT_SEARCH_STATE: SearchState = {
  page: 1,
  limit: 20,
};

export function useSearchState(initialState: Partial<SearchState> = {}) {
  const [searchState, setSearchState] = useState<SearchState>({
    ...DEFAULT_SEARCH_STATE,
    ...initialState,
  });

  const updateSearchState = (newState: Partial<SearchState>) => {
    setSearchState((prev) => ({
      ...prev,
      ...newState,
    }));
  };

  const resetSearchState = () => {
    setSearchState(DEFAULT_SEARCH_STATE);
  };

  return {
    searchState,
    updateSearchState,
    resetSearchState,
  };
}

export type { SearchState, FilterState, FilterCondition, SortOrder };
